import { AnalyticsTransformer, TrackingData } from '@panamax/app-state';

export const cancelPendingPaymentTransformer: AnalyticsTransformer = (
  tracking: TrackingData,
) => {
  const customerCount = tracking.data?.customerCount;
  const fileCount = tracking.data['file.fileCount'] || 0;
  const totalAmount = tracking.data?.totalAmount;
  return {
    'capability': tracking.data.capability,
    'event': tracking.data.event,
    customerCount,
    'file.fileCount': fileCount,
    totalAmount,
  };
};
